export default __webpack_public_path__ + "static/media/Ficha_sorgo.f424e472.png";